import { Product } from "../Models/Product";
import { getApi } from "./Api";

export const getCardNewDate = async () => {
    try{
        return await getApi<{date:string}>('config-app/get-date-new-cards')
    }
    catch(error){
        throw error;
    }
}

